import React from "react";
import { observer } from "mobx-react";
import { PropTypes } from "prop-types";
import { MrbPageContentHeader } from "mrb/components/layout";
import { MrbGrid } from "mrb/components/grid";
import { TableNoDataOverlay } from "common/components";
import { ContentStatsListLoader, NakiNigunListenersCell } from "administration/analytics/components";

function NakiNigunListTemplate({ nakiNigunListenersListViewStore, t }) {
    const { gridStore } = nakiNigunListenersListViewStore;
    return (
        <div store={nakiNigunListenersListViewStore} t={t}>
            <MrbPageContentHeader classNameOverride="c-container--base u-mar--bottom--sml"></MrbPageContentHeader>
            <div className="c-container--base">
                <div className="c-card--primary">
                    <div className="c-analytics__header">
                        <span className="c-analytics__header__item c-analytics__item--position">Position</span>
                        <span className="c-analytics__header__item c-analytics__item--name c-analytics__item--name--full">
                            Title
                        </span>
                        <span className="c-analytics__header__item c-analytics__item--score"># of Devices</span>
                    </div>
                    <MrbGrid
                        t={t}
                        store={gridStore}
                        classNameOverride="test"
                        emptyStateRender={TableNoDataOverlay}
                        loaderRender={() => <ContentStatsListLoader />}
                        cellRender={(props) => <NakiNigunListenersCell podcastId={props.item.id} {...props} />}
                    />
                </div>
            </div>
        </div>
    );
}

NakiNigunListTemplate.propTypes = {
    nakiNigunListenersListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(NakiNigunListTemplate);
